export default {
	title: "Settings",
	"search-sites": "Search sites",
	"set-source": "Set source",
	"set-source-for-selected-sites": "Set source for {{num}} selected sites",
	"select-all": "Select all",
	"no-table-rows": "No results",
	"feed-plan": "Feed plan",
	source: "Source",
	"previous-week-recommended": "Prev. week recommended",
	"previous-week-actual": "Prev. week actual",
	"this-week-recommended": "This week recommended",
	"this-week": "This week",
	manualplan: "Manual plan",
	feedstation: "FeedStation",
	farmer: "Farmer",
	"selected-source": "Selected source",
	week: "Week",
	total: "Total",
	"locales-update-failed": "Could not update locales",
	"locales-updated": "Locales updated",
	"failed-to-update-settings": "Failed to update settings",
	"settings-updated": "Settings updated",
	admin: {
		"details-title": "Details",
		environment: "Environment",
		version: "Version",
		language: "Language",
		"features-title": "Features",
		"feature-enabled": "Enabled",
		"feature-disabled": "Disabled",
		theme: "Theme",
	},
	general: {
		selectLanguage: "Language",
		selectTheme: "Theme",
		selectDecimalCount: "Decimal count",
	},
	liveConfigurations: {
		title: "Live configurations",
		customizeView: "Customize view",
		selectView: "Select view",
		defaultViewOption: "View: Default",
		selectViewDescription: "Choose which metrics to show in the view and save the changes, or save as a new view.",
		siteViewMode: {
			multiple: "Multiple sites",
			single: "Single site",
			description: "Changes will affect the view for single site. Go to multisite tab to change the view for multiple sites.",
		},
		feed: {
			title: "Feed progress",
			description: "Choose how you want to view feed progress.",
			show: "Show",
			checks: {
				intensity: "Intensity",
				amount: "Amount",
				target: "Target",
			},
		},
		cardSection: {
			overview: {
				title: "Show in top section",
				description: "Choose which metrics to show in the summary top section and the order in which they are displayed.",
			},
			cards: {
				title: "Show in cards",
				description: "Choose which metrics to show in the cards and the order in which they are displayed.",
			},
		},
		actions: {
			resetChanges: "Reset changes",
			saveAsNewView: "Save as new view",
			saveChangesToView: "Save changes to view",
		},
	},
	tabs: {
		general: "General",
		"live-configurations": "Live configurations",
		admin: "Admin",
	},
	language: {
		norwegian: "Norwegian",
		english: "English",
	},
	theme: {
		light: "Light",
		dark: "Dark",
	},
};
